import { render, staticRenderFns } from "./SoloStyle.vue?vue&type=template&id=7796f528&"
import script from "./SoloStyle.vue?vue&type=script&lang=js&"
export * from "./SoloStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports